import * as React from "react";
import NoticeModel from "./NoticeModel";
import { notification } from "antd";
import renderHtml from "./convertDraftToHtml";
// 通知模板公共配置
import { icon_fontSize, icon_bgColor, notice_duration } from "./tmpVariable";

import "./index.scss";

// 客服消息
class NCSNotice {
  static show(data: NoticeModel, syncClose) {
    const renderContent = content => {
      return renderHtml(content);
    };

    notification.open({
      message: <span>{data.createTime}</span>,
      duration: notice_duration,
      key: data.swId,
      description: (
        <div className="ncs-notice">
          <a >
            {data.from}@了{data.to}
          </a>
          <div className="ncs-content">{renderContent(data.content)}</div>
        </div>
      ),
      icon: (
        <i
          className="action-user action-tubiao15"
          style={{ color: icon_bgColor, fontSize: icon_fontSize }}
        />
      ),
      onClose: () => {
        syncClose(data.swId);
      }
    });
  }
}

export default NCSNotice;
